<p>delete-payment-processors works!</p>
